import { Injectable } from "@nestjs/common";
import { SpareStockCreateDto } from "./dto/spare-stock-create.dto";
import { SpareStockEntity } from "./entities/spare-stock-entity";

@Injectable()
export class SpareStockAdapter {

    convertDtoToEntity(dto: SpareStockCreateDto[]): SpareStockEntity[] {
        const empty = [];
        for (const req of dto) {
            const entity = new SpareStockEntity();
            entity.pch = req.pch;
            entity.customer = req.customer;
            entity.brand = req.brand;
            entity.hsncode = req.hsncode;
            entity.item = req.item;
            entity.name = req.name;
            entity.description = req.description;
            entity.location = req.location;
            entity.locationdescription = req.locationdescription;
            entity.color = req.colour;
            entity.lot = req.lot;
            entity.lotref1 = req.lotref1;
            entity.lotref2 = req.lotref2;
            entity.buyerdescription = req.buyerdescription;
            entity.remarks = req.remarks;
            entity.uom = req.uom;
            entity.reciept = req.reciept;
            entity.age = req.age;
            entity.ageingrange = req.ageingrange;
            entity.quantity = req.quantity;
            entity.value = req.value;
            entity.pono = req.pono;
            entity.supplier = req.supplier;
            entity.modeoftransport = req.modeoftransport;
            entity.status = req.status; 
            entity.createdUser = req.userName;
            entity.warehouse = req.warehouse;
            entity.filepath = req.filepath;
            entity.stockzone = req.stockzone;
            if (req.id) {
                entity.id = req.id;
                entity.updatedUser = req.userName;
            };
            empty.push(entity);
        }

        return empty;

    }


}